import APIService, { TLangSkippableRequestConfig } from '.';
import { IchangeStatusData } from './FlagServiceTypes';

export interface IFlagUpdate {
  status: string;
  iosVersion?: string | null;
  androidVersion?: string | null;
  countries?: string[];
  groups: {
    id?: string;
    name: string;
    customers: string[];
    businesses: string[];
  }[];
}

export default class FlagsService extends APIService {
  getFlags() {
    return this.get('/super-admin/feature-flag');
  }

  paginateFlags(query: Record<string, string> | string) {
    return this.get(`/super-admin/feature-flag?${this.getQueryString(query)}`);
  }

  changeStatus(flagId: string, body: IFlagUpdate) {
    return this.put(`/super-admin/feature-flag/${flagId}`, body);
  }

  createFlagDownloadUrl(body: { name: string; slug: string }) {
    const url = new URL(`${this.host()}/super-admin/feature-flag/download`);

    url.searchParams.append('slug', body.slug);
    url.searchParams.append('name', body.name);

    return url.toString();
  }

  // `skipLangHeader`: these two are the only calls in the legacy app that leave
  // the Twism API for a host whose CORS allow-list we do not own. The explicit
  // `Content-Type` already forces a preflight, and `x-lang` would have to be in
  // that service's `Access-Control-Allow-Headers` or the super-admin flags
  // panel would break with no visible symptom (TWISM-19940).
  getAllFlagsForAllEnvs() {
    return this.axios.get('https://ff.internal.twism.info/flags', {
      withCredentials: false,
      skipLangHeader: true,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
      }
    } as TLangSkippableRequestConfig);
  }

  refreshAllFlagsForAllEnvs() {
    return this.axios.get('https://ff.internal.twism.info/refresh-flags', {
      withCredentials: false,
      skipLangHeader: true,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
      }
    } as TLangSkippableRequestConfig);
  }
}
